import css from './verification.module.scss';
import {Button} from '../../components/button/button';
import {OTP} from '../../components/otp/otp';
import {Link} from '../../components/link/link';
import { useNavigate } from '@tanstack/react-location';

export const Verification = (): JSX.Element => {
	const navigate = useNavigate();

	const onFilled = (value: string) => {
		console.log('value: ', value);
	};

	const onSubmit = () => {
		navigate({to: '/verify'});
	};

	return (
		<div className={css.container}>
			<div className={css.header}>
				<h3>📲 Verify Your Account</h3>
				<p>A text message with a verification code has been sent to:</p>
				<span>+1 (201) 823 - 4247</span>
			</div>
			<OTP hasError={false} onFilled={onFilled} />
			<div className={css.sendCodeContainer}>
				<Link onClick={console.log}>Send A New Code</Link>
			</div>
			<div className={css.buttonContainer}>
				<Button onClick={onSubmit} name="🎁   Claim 2,000 SET Tokens" color="blue" />
			</div>
		</div>
	);
};
